<template>
  <div>
    <form
      @submit.prevent="saveData()"
      class="titan-form titan-inline-form mt-2"
      novalidate
    >
      <vue-form-generator
        ref="form"
        :schema="schema"
        :model="model"
        :options="formOptions"
      />
      <div class="text-center my-3">
        <button type="submit" class="btn btn-warning w-50">
          <font-awesome-icon v-if="loading" icon="spinner" class="mx-2" spin />
          Zmeniť heslo
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import VueFormGenerator from "vue-form-generator";
import { validateForm } from "@/utils";

export default {
  name: "ChangePassword",
  methods: {
    saveData() {
      this.loading = true;
      if (this.model.newPassword !== this.model.newPasswordRetry) {
        this.$store.dispatch("alert/warning", "Zadané heslá sa nezhodujú", {
          root: true
        });
        this.loading = false;
      } else {
        if (validateForm(this.$refs.form)) {
          this.$store
            .dispatch("account/changePassword", this.model)
            .then(() => {
              this.$emit("changed");
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      }
    }
  },
  data() {
    return {
      model: {
        oldPassword: "",
        newPassword: "",
        newPasswordRetry: ""
      },
      schema: {
        fields: [
          {
            type: "titanPassword",
            label: "Pôvodné heslo",
            model: "oldPassword",
            required: true,
            validator: VueFormGenerator.validators.string
          },
          {
            type: "titanPassword",
            label: "Nové heslo",
            model: "newPassword",
            min: 6,
            required: true,
            validator: VueFormGenerator.validators.string
          },
          {
            type: "titanPassword",
            label: "Potvrdenie hesla",
            model: "newPasswordRetry",
            min: 6,
            required: true,
            validator: VueFormGenerator.validators.string
          }
        ]
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
        validateAsync: false
      },
      loading: false
    };
  }
};
</script>

<style lang="scss" scoped>
.button-row {
  margin-top: -10px;

  small {
    display: block;
    line-height: 120%;
  }
}
</style>
